import React, { useState } from "react";
import { CustomSwitch } from "../../../../Components";
import { useTranslate } from "../../../../Hooks";

function AgentSwitch({ agentData, onChangeHandler, isDarkMode }) {
  const { translate } = useTranslate("NewAgentsRotationCriteria");
  const [isActive, setIsActive] = useState(agentData.isActive);
  const onChange = () => {
    setIsActive(!isActive);
    onChangeHandler(agentData, () => setIsActive(!isActive));
  };

  return (
    <>
      <label
        style={{
          fontWeight: 400,
          color: !isDarkMode ? "#475467" : "#94969C",
        }}
      ></label>
      <CustomSwitch
        label={translate("active")}
        name="status"
        size={"md"}
        checked={isActive}
        onChange={onChange}
      />
    </>
  );
}

export const AsignAgentsTableData = (
  isDarkMode = false,
  onChangeStatusHandler = () => {}
) => [
  {
    id: 1,
    formFieldId: 1,
    minWidth: 300,
    headerName: "Agent Name",
    field: "agentName",
    sortable: false,
    filterable: false,
    fieldType: "text",
    displayPath: "agentName",
    isDefaultFilterColumn: true,
    fieldKey: "agentName",
    formFieldTitle: "Agent Name",
    disableColumnMenu: true,
    searchKey: "Agent Name",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.agentName || "N/A"}
          <span style={{ display: "block" }}>{item?.row?.agentEmail}</span>
        </label>
      );
    },
  },
  {
    id: 13,
    formFieldId: 13,
    minWidth: 300,
    headerName: "Overall Capacity",
    field: "agentLeadCapacityInRotation",
    sortable: false,
    filterable: false,
    fieldType: "text",
    displayPath: "agentLeadCapacityInRotation",
    isDefaultFilterColumn: true,
    fieldKey: "agentLeadCapacityInRotation",
    formFieldTitle: "agentLeadCapacityInRotation",
    disableColumnMenu: true,
    searchKey: "agentLeadCapacityInRotation",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.agentLeadCapacityInRotation}
        </label>
      );
    },
  },
  {
    id: 2,
    formFieldId: 2,
    minWidth: 400,
    headerName: "Agent Capacity",
    field: "agentCapacity",
    sortable: false,
    filterable: false,
    fieldType: "text",
    displayPath: "agentCapacity",
    isDefaultFilterColumn: true,
    fieldKey: "agentCapacity",
    formFieldTitle: "Agent Capacity",
    disableColumnMenu: true,
    searchKey: "agentCapacity",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {`Up to ${item.row.monthlyCapacity} monthly . ${item?.row?.weeklyCapacity} weekly . ${item.row.dailyCapacity} daily`}
        </label>
      );
    },
  },
  {
    id: 3,
    formFieldId: 3,
    minWidth: 300,
    headerName: "Agent Status",
    field: "agentStatus",
    sortable: false,
    filterable: false,
    fieldType: "text",
    displayPath: "agentStatus",
    isDefaultFilterColumn: false,
    fieldKey: "agentStatus",
    formFieldTitle: "agentStatus",
    disableColumnMenu: true,
    searchKey: "agentStatus",
    renderCell: (item) => {
      return (
        <AgentSwitch
          key={item.row.agentId}
          agentData={item.row}
          onChangeHandler={onChangeStatusHandler}
          isDarkMode={isDarkMode}
        />
      );
    },
  },
  {
    id: 4,
    formFieldId: 4,
    minWidth: 300,
    headerName: "Schema Status",
    field: "schemaStatus",
    sortable: false,
    filterable: false,
    fieldType: "text",
    displayPath: "schemaStatus",
    isDefaultFilterColumn: true,
    fieldKey: "schemaStatus",
    formFieldTitle: "Schema Status",
    disableColumnMenu: true,
    searchKey: "Schema Status",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.agentStatus || "N/A"}
        </label>
      );
    },
  },
  {
    id: 5,
    formFieldId: 5,
    minWidth: 300,
    headerName: "Number of Leads",
    field: "numberOfLeadsAssigned",
    sortable: false,
    filterable: false,
    fieldType: "text",
    displayPath: "numberOfLeads",
    isDefaultFilterColumn: true,
    fieldKey: "numberOfLeads",
    formFieldTitle: "Number of Leads",
    disableColumnMenu: true,
    searchKey: "Number of Leads",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.numberOfLeads}
        </label>
      );
    },
  },
  {
    id: 6,
    formFieldId: 6,
    minWidth: 300,
    headerName: "Number of Active Leads",
    field: "numberOfActiveLeads",
    sortable: false,
    filterable: false,
    fieldType: "text",
    displayPath: "numberOfActiveLeads",
    isDefaultFilterColumn: true,
    fieldKey: "numberOfActiveLeads",
    formFieldTitle: "Number of Active Leads",
    disableColumnMenu: true,
    searchKey: "Number of Active Leads",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.numberOfActiveLeads}
        </label>
      );
    },
  },
  {
    id: 7,
    formFieldId: 7,
    minWidth: 300,
    headerName: "monthlyLeads",
    field: "monthlyLeads",
    sortable: false,
    filterable: false,
    fieldType: "text",
    displayPath: "monthlyLeads",
    isDefaultFilterColumn: true,
    fieldKey: "monthlyLeads",
    formFieldTitle: "monthlyLeads",
    disableColumnMenu: true,
    searchKey: "monthlyLeads",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.monthlyLeads}
        </label>
      );
    },
  },
  {
    id: 8,
    formFieldId: 8,
    minWidth: 300,
    headerName: "monthlyActiveLeads",
    field: "monthlyActiveLeads",
    sortable: false,
    filterable: false,
    fieldType: "text",
    displayPath: "monthlyActiveLeads",
    isDefaultFilterColumn: true,
    fieldKey: "monthlyActiveLeads",
    formFieldTitle: "monthlyActiveLeads",
    disableColumnMenu: true,
    searchKey: "monthlyActiveLeads",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.monthlyActiveLeads}
        </label>
      );
    },
  },
  {
    id: 9,
    formFieldId: 9,
    minWidth: 300,
    headerName: "weeklyLeads",
    field: "weeklyLeads",
    sortable: false,
    filterable: false,
    fieldType: "text",
    displayPath: "weeklyLeads",
    isDefaultFilterColumn: true,
    fieldKey: "weeklyLeads",
    formFieldTitle: "weeklyLeads",
    disableColumnMenu: true,
    searchKey: "weeklyLeads",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.weeklyLeads}
        </label>
      );
    },
  },
  {
    id: 10,
    formFieldId: 10,
    minWidth: 300,
    headerName: "weeklyActiveLeads",
    field: "weeklyActiveLeads",
    sortable: false,
    filterable: false,
    fieldType: "text",
    displayPath: "weeklyActiveLeads",
    isDefaultFilterColumn: true,
    fieldKey: "weeklyActiveLeads",
    formFieldTitle: "weeklyActiveLeads",
    disableColumnMenu: true,
    searchKey: "weeklyActiveLeads",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.weeklyActiveLeads}
        </label>
      );
    },
  },
  {
    id: 11,
    formFieldId: 11,
    minWidth: 300,
    headerName: "dailyLeads",
    field: "dailyLeads",
    sortable: false,
    filterable: false,
    fieldType: "text",
    displayPath: "dailyLeads",
    isDefaultFilterColumn: true,
    fieldKey: "dailyLeads",
    formFieldTitle: "dailyLeads",
    disableColumnMenu: true,
    searchKey: "dailyLeads",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.dailyLeads}
        </label>
      );
    },
  },
  {
    id: 12,
    formFieldId: 12,
    minWidth: 300,
    headerName: "dailyActiveLeads",
    field: "dailyActiveLeads",
    sortable: false,
    filterable: false,
    fieldType: "text",
    displayPath: "dailyActiveLeads",
    isDefaultFilterColumn: true,
    fieldKey: "dailyActiveLeads",
    formFieldTitle: "dailyActiveLeads",
    disableColumnMenu: true,
    searchKey: "dailyActiveLeads",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.dailyActiveLeads}
        </label>
      );
    },
  },
];
